import React from "react";
import { motion } from "framer-motion";
import { AlertTriangle, CheckCircle2, ClipboardCheck } from "lucide-react";
import { MISTAKES, CHECKLIST } from "../data/content";

export const MistakesChecklist = () => {
  return (
    <section id="checklist" className="py-20 sm:py-28 bg-[#F9FAFB]" data-testid="mistakes-checklist-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-8">
        {/* Errori */}
        <div>
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-brand">Errori da evitare</span>
          <h1 className="mt-3 font-heading text-3xl font-bold tracking-tight text-brand-deep">Cosa non fare</h1>
          <div className="mt-8 space-y-3">
            {MISTAKES.map((m, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -16 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.05 }}
                className="flex items-start gap-3 rounded-2xl bg-white border border-gray-100 p-4 shadow-sm"
                data-testid={`mistake-${i}`}
              >
                <span className="mt-0.5 flex h-9 w-9 flex-none items-center justify-center rounded-xl bg-red-50 text-red-500">
                  <AlertTriangle size={18} strokeWidth={2.5} />
                </span>
                <div>
                  <p className="font-heading font-semibold text-brand-deep">{m.title}</p>
                  <p className="font-body text-[15px] text-ink mt-0.5">{m.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Checklist */}
        <div>
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-brand">Checklist mensile</span>
          <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-brand-deep">Da fare ogni mese</h2>
          <motion.div
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
            className="mt-8 rounded-3xl bg-white border border-gray-100 shadow-sm p-7"
          >
            <div className="flex items-center gap-2 text-brand">
              <ClipboardCheck size={20} strokeWidth={2.5} />
              <span className="font-heading font-semibold">La tua routine vincente</span>
            </div>
            <ul className="mt-5 space-y-3.5">
              {CHECKLIST.map((c, i) => (
                <li key={i} className="flex items-start gap-3 font-body text-ink" data-testid={`checklist-${i}`}>
                  <CheckCircle2 size={20} className="mt-0.5 flex-none text-brand-green" strokeWidth={2.5} />
                  <span className="text-[15px]">{c}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
